import { transformImage } from "../utils/image-utils";

interface BaseImageProps {
  imageUrl: string;
  alt: string;
  className?: string;
  attributes?: { [key: string]: string };
  width?: number;
  isPrivate?: boolean;
}

export const BaseImage = (props: BaseImageProps) => {
  const {
    alt,
    imageUrl,
    className = "",
    attributes = {},
    width = 720,
    isPrivate = false,
  } = props;

  const imageSrc = transformImage(imageUrl, {
    width,
  });
  // Make sure the intrinsic size isn't larger than the maximum image size.
  const srcSetSizes = [320, 576, 720, 992, 1200, 1440].filter(
    (size) => size <= width
  );

  if (!srcSetSizes.includes(width)) {
    srcSetSizes.push(width);
  }

  const srcSet = srcSetSizes
    .map((width) => `${transformImage(imageUrl, { width })} ${width}w`)
    .join(", ");
  const sizes =
    "(max-width: 640px) 90vw, (max-width: 768px) 90vw, (max-width: 1024px) 50vw, (max-width: 1280px) 50vw, (max-width: 1536px) 50vw, 50vw";

  if (isPrivate) {
    return (
      <img
        {...attributes}
        className={className}
        loading="lazy"
        src={imageUrl}
        alt={alt}
      />
    );
  }

  return (
    <img
      {...attributes}
      className={className}
      loading="lazy"
      src={imageSrc}
      sizes={sizes}
      srcSet={srcSet}
      alt={alt}
    />
  );
};
